import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';

import { useStore } from '@vromo/mobx-react';
import orderBy from 'lodash/orderBy';

import { css } from 'emotion';

import Title from '@vromo/ui/components/Title';
import Container from '@vromo/ui/components/Container';
import Button from '@vromo/ui/components/Button';
import Table from '@vromo/ui/components/Table';

import { RootStore } from '../stores/RootStore';
import { Blueprint } from '@vromo/models';
import BlueprintEditor from './BlueprintEditor';
import { ProfilePlaceholder } from '@vromo/ui/components/ProfileImage';
import { EMPTY_BLUEPRINT } from '@vromo/dashboard/src/blueprints/BlueprintDefaults';

export const BlueprintRow = observer(function BlueprintRow({
    onClick,
    blueprint
}: {
    onClick: () => void;
    blueprint: Blueprint;
}) {
    return (
        <tr onClick={onClick} style={{ cursor: 'pointer' }}>
            <td style={{ textAlign: 'center', width: 50 }}>
                <ProfilePlaceholder initials={blueprint.name[0]} id={blueprint.id} />
            </td>
            <td>{blueprint.name}</td>
            <td>{blueprint.id}</td>
        </tr>
    );
});

export default observer(function Blueprints() {
    const { blueprintStore } = useStore<RootStore>('rootStore');

    const [editing, setEditing] = useState<boolean>(false);
    const [editedBlueprint, setEditedBlueprint] = useState<Blueprint>(() => EMPTY_BLUEPRINT());

    return (
        <>
            <div
                className={css`
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 0px 16px;
                `}>
                <Title>Job Templates</Title>
                <Button
                    onClick={() => {
                        setEditing(true);
                        setEditedBlueprint(EMPTY_BLUEPRINT);
                    }}>
                    Add New Job Template
                </Button>
            </div>
            <Container>
                <div
                    className={css`
                        width: 100%;
                        overflow: auto;
                        margin-top: 15px;
                    `}>
                    <Table>
                        <thead>
                            <tr>
                                <th />
                                <th>Name</th>
                                <th>ID</th>
                            </tr>
                        </thead>
                        <tbody>
                            {orderBy(
                                blueprintStore.blueprints.items,
                                (it) => it.name.trim().toLowerCase(),
                                ['asc']
                            ).map((blueprint: Blueprint) => (
                                <BlueprintRow
                                    key={blueprint.id}
                                    onClick={() => {
                                        setEditing(true);
                                        setEditedBlueprint(blueprint);
                                    }}
                                    blueprint={blueprint}
                                />
                            ))}
                        </tbody>
                    </Table>
                </div>
                <BlueprintEditor
                    open={editing}
                    close={() => {
                        setEditing(false);
                    }}
                    blueprint={editedBlueprint}
                    isNew={editedBlueprint.id === undefined}
                />
            </Container>
        </>
    );
});
